import { ValidationError } from "spraypaint/lib-esm/validation-errors";
import RecruiterUser from "../../apiResources/RecruiterUser";

/* eslint-disable import/prefer-default-export */
export const formatCurrentPasswordError = (
  error: ValidationError<RecruiterUser>
) => {
  if (!error) {
    return null;
  }

  // We need to set the error on the client because the invalid password message
  // returning from the BE is insane and doesn't make any sense in this context.
  return error.title === "Validation Error"
    ? "Your password is incorrect, please try again"
    : error.fullMessage;
};
